/* Homepage cover: a short muted clip plays once over the photo, then holds on its last frame.
   The photo stays as the fallback, so the page looks right if the video is blocked, slow or not wanted. */
(function () {
  var hero = document.querySelector('.classic-hero[data-hero-video]');
  if (!hero) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  if (reduce || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;

  function start() {
    var photo = hero.querySelector('.classic-hero__photo');
    var shade = hero.querySelector('.classic-hero__shade');
    var v = document.createElement('video');
    v.className = 'classic-hero__video';
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.setAttribute('aria-hidden', 'true');
    v.tabIndex = -1;
    v.preload = 'auto';
    if (photo) v.style.objectPosition = getComputedStyle(photo).objectPosition;
    v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
    v.addEventListener('error', function () { v.remove(); });
    v.src = hero.getAttribute('data-hero-video');
    hero.insertBefore(v, shade || null);
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.remove(); });
  }

  function later() { setTimeout(start, 300); }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later);
})();